import React from "react";
import { Editor, EditorState, RichUtils } from "draft-js";
import { convertToHTML, convertFromHTML } from "draft-convert";

import logger from "../../../utils/LoggerFrontend";

const htmlFragment = "<div>Stellenanzeige</div>";

export default class DraftjsEditor extends React.Component {
  constructor(props) {
    logger.debug("DraftjsEditor:constructor", "constructor...", props);

    const editorState = EditorState.createWithContent(convertFromHTML(props.value || htmlFragment));

    super(props);
    this.state = {
      editorState: editorState
    };

    this.onChange = (editorState) => {
      this.setState({ editorState }, () => {
        this.onChangeEditor();
      });

      logger.debug("DraftjsEditor:onChange", "called...", {});
    };
    this.handleKeyCommand = this.handleKeyCommand.bind(this);
  }

  handleKeyCommand(command, editorState) {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return "handled";
    }
    return "not-handled";
  }

  onChangeEditor() {
    const { editorState } = this.state;

    let html = htmlFragment;

    html = convertToHTML({
      styleToHTML: (style) => {},
      blockToHTML: (block) => {
        if (block.type === "PARAGRAPH") {
          return <p />;
        }
        if (block.type === "section") {
          return <p />;
        }
        if (block.type === "unstyled") {
          if (block.text === " " || block.text === "") return <br />;
        }
      },
      entityToHTML: (entity, originalText) => {
        if (entity.type === "LINK") {
          return <a href={entity.data.url}>{originalText}</a>;
        }
        return originalText;
      }
    })(editorState.getCurrentContent());

    this.props.onChange(html);
  }
  _onInlineStyleChange(value) {
    this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, value));
  }

  _onBlockStyle(value) {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, value));
  }
  handleReturn(e) {
    const { editorState } = this.state;
    if (e.shiftKey) {
      this.setState({ editorState: RichUtils.insertSoftNewline(editorState) });
      return "handled";
    }
    return "not-handled";
  }

  render() {
    const { editorState } = this.state;

    return (
      <div
        style={{
          textAlign: "left",
          fontFamily:
            "-apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'System San Francisco Display Regular', sans-serif",
          fontWeight: "400",
          lineHeight: "1.4em",
          width: "560px",
          position: "relative",
          top: "-20px"
        }}
      >
        <div>
          <button onClick={this._onInlineStyleChange.bind(this, "BOLD")}>Bold</button>
          <button onClick={this._onInlineStyleChange.bind(this, "ITALIC")}>Italic</button>
          <button onClick={this._onBlockStyle.bind(this, "header-one")}>H1</button>
          <button onClick={this._onBlockStyle.bind(this, "header-two")}>H2</button>
          <button onClick={this._onBlockStyle.bind(this, "header-three")}>H3</button>
          <button onClick={this._onBlockStyle.bind(this, "unordered-list-item")}>List</button>
          <Editor
            editorState={editorState}
            onChange={this.onChange}
            handleReturn={this.handleReturn.bind(this)}
            handleKeyCommand={this.handleKeyCommand}
          />
        </div>
      </div>
    );
  }
}
